import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { Form } from '@/components/functional/Form/Form';
import { MultiTextField } from '@/components/functional/Form/MultiTextField';
import { FieldLabel } from '@/components/ui/Form/FieldLabel';
import { HotLineFormActions } from '@/feature/hotline/component/HotLineFormActions';
import { HotlineFormLayout } from '@/feature/hotline/component/HotlineFormLayout';
import { hotlineProFirstReplyBreadcrumbs } from '@/feature/hotline/professional/firstReply/constant/breadcrumbs';
import { hotlineProFirstReplyText } from '@/feature/hotline/professional/firstReply/constant/text';
import { hotlineProFirstReplyInputViewStyle } from '@/feature/hotline/professional/firstReply/input/page/style';
import { hotlineProFirstReplyFormSchema } from '@/feature/hotline/professional/firstReply/util/hotlineProFirstReplyFormSchema';
import { FIELD_DOM_CLASS_NAME } from '@/utils/form/scroll';
import { zodFinalFormValidate } from '@/utils/libs/zod/validate';
import { pagePath } from '@/utils/router/pagePath';
const initialValues = {
    agenda: `クライアントの業界や検討テーマと関連する実績や知見の強みを記載してください。\n
（記載例）
・〇〇業界でのプロジェクト実績は約〇件あります。
・〇〇プロジェクトや、〇〇プロジェクトの支援経験があり〇〇の知見が豊富です。
・特に、〇〇を検討する際のノウハウには自信があります。
・〇〇についてはセミナーも多数実施しており、〇〇のアドバイスが出来ます。`,
    description: `クライアントにチャットを通じて回答してほしい内容を記載してください。
相談内容に見合った的確な質問を投稿したコンサルタントが選ばれる傾向があるため
質問事項は「3つ程度に厳選」して頂くことをお薦めします。\n
※匿名を希望している場合、社名や部門名を質問することはお控えください。`,
    similarProject: `クライアントが相談を通じて得られる具体的な成果について記載してください。\n
（記載例）
・〇〇に関する事例について〇〇の観点で詳細にお話できます。
・〇〇の経験から、〇〇の進め方や失敗のポイントを体系的に解説出来ます。
・〇〇のプロセスについて具体的な手順や情報ソースを共有できます。
・〇〇については関連資料を提供することが出来ます。
・相談の最後には、〇〇についてまとめられるよう議論をリードします。`,
};
const { label } = hotlineProFirstReplyText;
/**
 * ホットライン 初回返信 入力画面（View 部分のみ）
 * @description View 全体の表示, api 取得データを表示用に変換して渡す
 */
export const HotlineProFirstReplyInputView = (props) => {
    const { defaultValues, id, onSubmit, prevLink, title } = props;
    /** パンくず */
    const breadcrumbs = useMemo(() => hotlineProFirstReplyBreadcrumbs('input', id, title), [id, title]);
    const style = hotlineProFirstReplyInputViewStyle();
    return (_jsx(HotlineFormLayout, Object.assign({ breadcrumbs: breadcrumbs, formTitle: '初回返信内容を入力', pageTitle: title }, { children: _jsx(Form, { initialValues: defaultValues !== null && defaultValues !== void 0 ? defaultValues : initialValues, onSubmit: onSubmit, render: ({ handleSubmit, submitting }) => (_jsxs("form", Object.assign({ onSubmit: handleSubmit }, { children: [_jsxs("div", Object.assign({ className: style.fieldWrap() }, { children: [_jsx(FieldLabel, Object.assign({ className: FIELD_DOM_CLASS_NAME, commentTextClassName: style.commentText(), isRequired: true, labelText: label.similarProject() }, { children: _jsx(MultiTextField, { minRows: 4, name: 'similarProject' }) })), _jsx(FieldLabel, Object.assign({ className: FIELD_DOM_CLASS_NAME, commentTextClassName: style.commentText(), isRequired: true, labelText: label.agenda() }, { children: _jsx(MultiTextField, { minRows: 4, name: 'agenda' }) })), _jsx(FieldLabel, Object.assign({ className: FIELD_DOM_CLASS_NAME, commentTextClassName: style.commentText(), isRequired: true, labelText: label.description() }, { children: _jsx(MultiTextField, { minRows: 4, name: 'description' }) })), _jsx(FieldLabel, Object.assign({ className: FIELD_DOM_CLASS_NAME, labelText: label.other() }, { children: _jsx(MultiTextField, { minRows: 4, name: 'other', placeholder: 'その他のメッセージを入力してください' }) }))] })), _jsx(HotLineFormActions, { backTo: prevLink || pagePath.hotline.professional.detail(id), submitting: submitting, type: 'input' })] }))), validate: zodFinalFormValidate(hotlineProFirstReplyFormSchema) }) })));
};
